import { Dispatch, useEffect } from 'react'
import getBudgetGuidance, { collectionMapper } from '../../../Constants/budgetGuidance'
import BudgetGuidanceBarChart from './BudgetGuidanceBarChart'
import { PartialBrief } from '../../../Types/Brief'
import { Currency } from '../../../Types/generated-types'

interface BudgetGuidanceProps {
  brief: PartialBrief
  currency?: Currency
  setBudgetGuidance: Dispatch<BudgetGuidanceType>
}

export type BudgetGuidanceType = {
  budgetGuidanceBasic?: number | null
  budgetGuidanceAverage?: number | null
  budgetGuidanceHighEnd?: number | null
}

export function addCommasToNumber(number: number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const BudgetGuidance = ({
  brief,
  currency,
  setBudgetGuidance,
}: BudgetGuidanceProps): JSX.Element => {
  const {
    collection: collectionNumber,
    collectionName: _collectionName,
    leadFeedCity,
    capacities: numGuests,
  } = brief
  if (!collectionNumber || !_collectionName || !leadFeedCity || !numGuests) {
    return <></>
  }

  const collectionName = collectionMapper[collectionNumber]
    ? collectionMapper[collectionNumber]
    : _collectionName + ' events'

  const { basic, average, highEnd } = getBudgetGuidance(brief) || {}
  if (!basic || !average || !highEnd) {
    return <></>
  }
  const round_to = 5
  const basicBudget = Math.round((basic * numGuests) / round_to) * round_to
  const averageBudget = Math.round((average * numGuests) / round_to) * round_to
  const highEndBudget = Math.round((highEnd * numGuests) / round_to) * round_to

  const numPersonText = numGuests === 1 ? numGuests + ' person' : numGuests + ' people'

  useEffect(() => {
    setBudgetGuidance({
      budgetGuidanceBasic: basicBudget,
      budgetGuidanceAverage: averageBudget,
      budgetGuidanceHighEnd: highEndBudget,
    })
  }, [basicBudget, averageBudget, highEndBudget])

  return (
    <div style={{ paddingTop: '24px' }}>
      <text style={{ color: '#262626' }}>
        <b>
          {collectionName} in {leadFeedCity} for {numPersonText} usually cost {currency?.symbol}
          {addCommasToNumber(basicBudget)} to {currency?.symbol}
          {addCommasToNumber(highEndBudget)}.
        </b>{' '}
        <br />
        <text className='NON_MOBILE_BUDGET_GUIDANCE'>
          Prices will vary by date, location and additional services.
        </text>
      </text>

      {currency && basicBudget && averageBudget && highEndBudget && (
        <BudgetGuidanceBarChart
          currencySymbol={currency.symbol}
          basicBudget={basicBudget}
          averageBudget={averageBudget}
          highEndBudget={highEndBudget}
        />
      )}
      <text className='MOBILE_BUDGET_GUIDANCE'>
        Prices will vary by date, location and additional services.
      </text>
    </div>
  )
}

export default BudgetGuidance
